import { Phone } from "lucide-react";
import { useCompanyInfo } from "@/context/CompanyInfoContext";

/**
 * StickyCallBar — pinned to the bottom of the viewport on mobile only.
 * Shows one or two tap-to-call tiles based on configured company phones.
 * Hidden entirely when no phone numbers are set.
 */
export default function StickyCallBar() {
  const { info } = useCompanyInfo();
  const p1 = info?.phone;
  const p2 = info?.phone_secondary;
  if (!p1 && !p2) return null;

  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-[var(--lt-border)] bg-[var(--lt-bg)]/95 backdrop-blur"
      data-testid="sticky-call-bar"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex divide-x divide-[var(--lt-border)]">
        {p1 && (
          <a
            href={`tel:${p1}`}
            data-testid="sticky-call-primary"
            className="flex-1 flex items-center justify-center gap-2 py-3 text-white active:bg-[var(--lt-accent)] transition-colors"
          >
            <Phone className="h-4 w-4 text-[var(--lt-accent-bright)]" />
            <div className="flex flex-col items-start leading-tight">
              <span className="text-[10px] font-mono-lt uppercase tracking-[0.2em] text-slate-400">
                {info?.phone_label || "Dispatch"}
              </span>
              <span className="font-head text-sm">{p1}</span>
            </div>
          </a>
        )}
        {p2 && (
          <a
            href={`tel:${p2}`}
            data-testid="sticky-call-secondary"
            className="flex-1 flex items-center justify-center gap-2 py-3 text-white active:bg-[var(--lt-accent)] transition-colors"
          >
            <Phone className="h-4 w-4 text-[var(--lt-accent-bright)]" />
            <div className="flex flex-col items-start leading-tight">
              <span className="text-[10px] font-mono-lt uppercase tracking-[0.2em] text-slate-400">
                {info?.phone_secondary_label || "Alternate"}
              </span>
              <span className="font-head text-sm">{p2}</span>
            </div>
          </a>
        )}
      </div>
    </div>
  );
}
